module.exports = __webpack_public_path__ + "static/media/26UNRWA12.651f9802.jpg";